import { jsxs, jsx } from "react/jsx-runtime";
import { Image } from "@zillow/constellation";
import { withPreload, Source, Picture as Picture$1 } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import React from "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import StructuredData from "../../components/StructuredData/StructuredData.esm.js";
import { withAnchor } from "../../util/helpers.esm.js";
const SourcePreload = withPreload(Source);
const ImagePreload = withPreload(Image);
const BlockPicture = ({
  attrs,
  index
}) => {
  const {
    desktop,
    tablet,
    mobile,
    loading = "lazy",
    decoding = "async"
  } = attrs;
  const structuredData = [desktop, tablet, mobile].filter((picture) => Boolean(picture == null ? void 0 : picture.src)).map((picture) => ({
    "@context": "https://schema.org/",
    "@type": "ImageObject",
    contentUrl: picture.src,
    caption: picture.alt,
    height: picture.height,
    width: picture.width
  }));
  const isPost = usePlacement() === "post";
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(StructuredData, { data: structuredData }),
    /* @__PURE__ */ jsxs(Picture$1, { ...isPost && {
      marginBottom: "md"
    }, children: [
      mobile && /* @__PURE__ */ jsx(SourcePreload, { srcSet: mobile.src, width: mobile.width, height: mobile.height, loading, decoding, media: "sm_lte" }),
      tablet && /* @__PURE__ */ jsx(SourcePreload, { srcSet: tablet.src, width: tablet.width, height: tablet.height, loading, decoding, media: "lg_lte" }),
      desktop && /* @__PURE__ */ jsx(ImagePreload, { src: desktop.src, width: desktop.width, height: desktop.height, alt: desktop.alt, loading, decoding })
    ] }, index)
  ] });
};
BlockPicture.propTypes = {
  attrs: PropTypes.shape({
    desktop: PropTypes.shape({
      src: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
      alt: PropTypes.string
    }),
    tablet: PropTypes.shape({
      src: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number
    }),
    mobile: PropTypes.shape({
      src: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number
    }),
    loading: PropTypes.string
  }),
  index: PropTypes.number
};
const Picture = withAnchor(BlockPicture);
export {
  Picture as default
};
